import { createSelector } from 'reselect';
 
const selectOneUsers = (state: any) => state.oneUsers;
 
export const selectOneUsersCurrentItem = createSelector([selectOneUsers], (oneUsers) => oneUsers.current);
 
export const selectOneUsersListItems = createSelector([selectOneUsers], (oneUsers) => oneUsers.list);
 
 
export const selectOneUsersItemById = (itemId: any) =>
    createSelector(selectOneUsersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectOneUsersQueryItems = createSelector([selectOneUsers], (oneUsers) => oneUsers.query);

export const selectOneUsersCreatedItem = createSelector([selectOneUsers], (oneUsers) => oneUsers.create);
 
export const selectOneUsersUpdatedItem = createSelector([selectOneUsers], (oneUsers) => oneUsers.update);
 
export const selectOneUsersReadItem = createSelector([selectOneUsers], (oneUsers) => oneUsers.read);
 
export const selectOneUsersDeletedItem = createSelector([selectOneUsers], (oneUsers) => oneUsers.delete);
 
export const selectOneUsersSearchedItems = createSelector([selectOneUsers], (oneUsers) => oneUsers.search);
 
export const selectOneUsersItemsCount = createSelector([selectOneUsers], (oneUsers) => oneUsers.count);
 
export const selectOneUsersItemsFilter = createSelector([selectOneUsers], (oneUsers) => oneUsers.filter);

export const selectOneUsersGenerateDataExportItem = createSelector([selectOneUsers], (oneUsers) => oneUsers.generateDataExport);

export const selectOneUsersUploadCreateItem = createSelector([selectOneUsers], (oneUsers) => oneUsers.uploadCreate);
